import type { i18n } from 'i18next';

export const getAFormByCode = (code: string | undefined, i18n: i18n) => {
    switch (code) {
        case 'SOAJ':
            return i18n.t('aAnForms.SOAJ');
        case 'SOLN':
            return i18n.t('aAnForms.SOLN');
        case 'SOPN':
            return i18n.t('aAnForms.SOPN');
        case 'SOCT':
            return i18n.t('aAnForms.SOCT');
        case 'SOSY':
            return i18n.t('aAnForms.SOSY');
        case 'SUPN':
            return i18n.t('aAnForms.SUPN');
        case 'SUSP':
            return i18n.t('aAnForms.SUSP');
        default:
            return code;
    }
};
